"use client"

import { useState, useEffect } from "react"
import axios from "axios"
import { useParams, Link } from "react-router-dom"
import { useNavigate } from "react-router-dom"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditOrder = () => {
    const { id } = useParams()

    const [orderInfo, setOrderInfo] = useState({
        order_id: "",
        invoice_id: "",
        invoice_link: "",
        awb_number: "",
        courier_partner: "",
        tracking_link: "",
        invoice_amount: "",
        payment_mode: "COD",
        amount_status: "Not Received",
        settled_date: "",
        vendor_email: "",
        shipping_label: "",
        order_details: "",
        invoice_date: "",        // NEW
        billing_address: "",
        shipping_address:"",    // NEW
        place_of_supply: "",
        // original_name: "",     // NEW
        shipping_charges: "",  // NEW
        other_charges: "",     // NEW
        order_comments: ""     // NEW
    })
    const navigate = useNavigate()

    const [isSubmitting, setIsSubmitting] = useState(false)
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(false)

    // Dropdowns
    const [vendors, setVendors] = useState([])
    const [filteredVendors, setFilteredVendors] = useState([])
    const [showVendorDropdown, setShowVendorDropdown] = useState(false)

    const [couriers, setCouriers] = useState([])
    const [filteredCouriers, setFilteredCouriers] = useState([])
    const [showCourierDropdown, setShowCourierDropdown] = useState(false)

    useEffect(() => {
        fetchOrderDetails()
        fetchVendors()
        fetchCouriers()
    }, [])

    // fetch full order details to fill form
    const fetchOrderDetails = async () => {
        try {
            const res = await axios.get(
                `https://logicx.premierlam.com/api/pixel-get-all-order`,
                { headers: { authorization: localStorage.getItem("accessToken") } }
            )

            const found = res.data.data.find((o) => o.id == id)
            if (found) {
                setOrderInfo({
                    order_id: found.order_id || "",
                    invoice_id: found.invoice_id || "",
                    invoice_link: found.invoice_link || "",
                    awb_number: found.awb_number || "",
                    courier_partner: found.courier_partner || "",
                    tracking_link: found.tracking_link || "",
                    invoice_amount: found.invoice_amount || "",
                    payment_mode: found.payment_mode || "COD",
                    amount_status: found.amount_status || "Not Received",
                    settled_date: found.settled_date || "",
                    vendor_email: found.vendor_name ? found.vendor_email : "",
                    shipping_label: found.shipping_label || "",
                    order_details: found.order_details || "",
                    invoice_date: found.invoice_date || "",           // NEW
                    billing_address: found.billing_address || "", 
                    shipping_address_address: found.shipping_address || "",  // NEW
                    place_of_supply: found.place_of_supply || "",
                    // original_name: found.original_name || "",            // NEW
                    shipping_charges: found.shipping_charges || "",      // NEW
                    other_charges: found.other_charges || "",            // NEW
                    order_comments: found.order_comments || ""           // NEW
                })
            }
        } catch (err) {
            console.log(err)
        }
    }

    const fetchVendors = async () => {
        const res = await axios.get(
            `https://logicx.premierlam.com/api/pixel-get-all-vendor-email-name`,
            { headers: { authorization: localStorage.getItem("accessToken") } }
        )
        setVendors(res.data.data)
        setFilteredVendors(res.data.data)
    }

    const fetchCouriers = async () => {
        const res = await axios.get(
            `https://logicx.premierlam.com/api/get-pixel-courier-partner`,
            { headers: { authorization: localStorage.getItem("accessToken") } }
        )
        setCouriers(res.data.data)
        setFilteredCouriers(res.data.data)
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target
        setOrderInfo((prev) => ({ ...prev, [name]: value }))

        if (name === "vendor_email") {
            setFilteredVendors(
                vendors.filter((v) =>
                    `${v.full_name} ${v.email}`.toLowerCase().includes(value.toLowerCase())
                )
            )
            setShowVendorDropdown(true)
        }

        if (name === "courier_partner") {
            setFilteredCouriers(
                couriers.filter((c) =>
                    c.courier_partner_name.toLowerCase().includes(value.toLowerCase())
                )
            )
            setShowCourierDropdown(true)
        }
    }

    const handleVendorSelect = (email) => {
        setOrderInfo((prev) => ({ ...prev, vendor_email: email }))
        setShowVendorDropdown(false)
    }

    const handleCourierSelect = (name) => {
        setOrderInfo((prev) => ({ ...prev, courier_partner: name }))
        setShowCourierDropdown(false)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        try {
            setIsSubmitting(true)
            setError(null)
            setSuccess(false)

            await axios.put(
                `https://logicx.premierlam.com/api/pixel-update-orders/${id}`,
                orderInfo,
                {
                    headers: {
                        authorization: localStorage.getItem("accessToken"),
                        "Content-Type": "application/json",
                    },
                }
            )

            setSuccess(true)
            toast.success("Order updated successfully!");
            // wait for success message then redirect
            setTimeout(() => {
                navigate("/all-order")
            }, 1000)


        } catch (err) {
            console.log("UPDATE ERROR:", err.response?.data);
            const msg = err.response?.data?.message || "Failed to update order";
            toast.error(msg);
            setError(msg);

        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <> <ToastContainer position="top-right" autoClose={3000} />
            <div className="min-h-screen bg-gray-50 p-6">
                <div className="max-w-7xl mx-auto">

                    {/* HEADER */}
                    <div className="flex justify-between items-center mb-6">
                        <div>
                            <h1 className="text-2xl font-semibold text-gray-700">Edit Order</h1>
                            <p className="text-gray-500">Update order details</p>
                        </div>
                        <Link
                            to="/all-order"
                            className="bg-gray-800 hover:bg-gray-900 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                            Back to Orders
                        </Link>
                    </div>

                    {/* messages */}
                    {error && (
                        <div className="mb-6 p-3 bg-red-50 border border-red-200 rounded-lg">
                            <p className="text-sm text-red-600">{error}</p>
                        </div>
                    )}
                    {success && (
                        <div className="mb-6 p-3 bg-green-50 border border-green-200 rounded-lg">
                            <p className="text-sm text-green-600">Order updated successfully!</p>
                        </div>
                    )}

                    {/* FORM */}
                    <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                            <input className="hidden" />
                            {/* Order ID (Read Only) */}
                            <div >
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Order ID
                                </label>
                                <input
                                    type="text"
                                    value={orderInfo.order_id}
                                    disabled
                                    className="w-full px-4 py-2 bg-gray-100 border border-gray-300 rounded-md cursor-not-allowed"
                                />
                            </div>

                            {/* Invoice ID */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Invoice ID</label>
                                <input
                                    type="text"
                                    name="invoice_id"
                                    value={orderInfo.invoice_id}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                                />
                            </div>

                            {/* Invoice Link */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Invoice Link</label>
                                <input
                                    type="text"
                                    name="invoice_link"
                                    value={orderInfo.invoice_link}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                                />
                            </div>

                            {/* AWB */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">AWB Number</label>
                                <input
                                    type="text"
                                    name="awb_number"
                                    value={orderInfo.awb_number}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                                />
                            </div>

                            {/* COURIER DROPDOWN */}
                            <div className="relative">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Courier Partner</label>
                                <input
                                    type="text"
                                    name="courier_partner"
                                    value={orderInfo.courier_partner}
                                    onChange={handleInputChange}
                                    onFocus={() => setShowCourierDropdown(true)}
                                    onBlur={() => setTimeout(() => setShowCourierDropdown(false), 200)}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                                    placeholder="Search or select courier"
                                />

                                {showCourierDropdown && (
                                    <ul className="absolute z-10 bg-white border border-gray-200 w-full rounded-md max-h-40 mt-1 overflow-y-auto">
                                        {filteredCouriers.map((c) => (
                                            <li
                                                key={c.id}
                                                onClick={() => handleCourierSelect(c.courier_partner_name)}
                                                className="px-4 py-2 hover:bg-orange-100 cursor-pointer text-sm"
                                            >
                                                {c.courier_partner_name}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>

                            {/* Tracking Link */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Tracking Link</label>
                                <input
                                    type="text"
                                    name="tracking_link"
                                    value={orderInfo.tracking_link}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border rounded-md"
                                />
                            </div>

                            {/* Invoice amount */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Invoice Amount</label>
                                <input
                                    type="text"
                                    name="invoice_amount"
                                    value={orderInfo.invoice_amount}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border rounded-md"
                                />
                            </div>

                            {/* Payment mode */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Payment Mode</label>
                                <select
                                    name="payment_mode"
                                    value={orderInfo.payment_mode}
                                    onChange={handleInputChange}
                                    className="w-full border px-4 py-2 rounded-md"
                                >
                                    <option value="COD">COD</option>
                                    <option value="ONLINE">ONLINE</option>
                                </select>
                            </div>

                            {/* Amount Status */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Amount Status</label>
                                <select
                                    name="amount_status"
                                    value={orderInfo.amount_status}
                                    onChange={handleInputChange}
                                    className="w-full border px-4 py-2 rounded-md"
                                >
                                    <option>Received</option>
                                    <option>Not Received</option>
                                </select>
                            </div>

                            {/* Settled Date */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Settled Date</label>
                                <input
                                    type="date"
                                    name="settled_date"
                                    value={orderInfo.settled_date}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border rounded-md"
                                />
                            </div>

                            {/* VENDOR SEARCHABLE */}
                            <div className="relative">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Vendor</label>
                                <input
                                    type="text"
                                    name="vendor_email"
                                    value={orderInfo.vendor_email}
                                    onChange={handleInputChange}
                                    onFocus={() => setShowVendorDropdown(true)}
                                    onBlur={() => setTimeout(() => setShowVendorDropdown(false), 200)}
                                    className="w-full px-4 py-2 border rounded-md"
                                    placeholder="Search or select vendor"
                                />

                                {showVendorDropdown && (
                                    <ul className="absolute z-10 bg-white border border-gray-200 w-full rounded-md max-h-40 mt-1 overflow-y-auto">
                                        {filteredVendors.map((v, i) => (
                                            <li
                                                key={i}
                                                onClick={() => handleVendorSelect(v.email)}
                                                className="px-4 py-2 hover:bg-orange-100 cursor-pointer text-sm"
                                            >
                                                {v.full_name} ({v.email})
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>

                            {/* Shipping Label */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Shipping Label</label>
                                <input
                                    type="text"
                                    name="shipping_label"
                                    value={orderInfo.shipping_label}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border rounded-md"
                                />
                            </div>
                            {/* Invoice Date */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Invoice Date</label>
                                <input
                                    type="date"
                                    name="invoice_date"
                                    value={orderInfo.invoice_date}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border rounded-md"
                                />
                            </div>

                            {/* billing Address */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Billing Address</label>
                                <input
                                    type="text"
                                    name="billing_address"
                                    value={orderInfo.billing_address}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border rounded-md"
                                />
                            </div>
                              {/* shipping Address */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Shipping Address</label>
                                <input
                                    type="text"
                                    name="shipping_address"
                                    value={orderInfo.shipping_address}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border rounded-md"
                                />
                            </div>

                            {/* Place of Supply */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Place Of Supply</label>
                                <input
                                    type="text"
                                    name="place_of_supply"
                                    value={orderInfo.place_of_supply}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border rounded-md"
                                />
                            </div>
                            {/* original name */}
                            {/* <div>
                           
                            <label className="block text-sm font-medium text-gray-700 mb-1">Original Name</label>
                            <input
                                type="text"
                                name="original_name"
                                value={orderInfo.original_name}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border rounded-md"
                            />
                        </div> */}
                            {/* shippingcharges */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Shipping Charges</label>
                                <input
                                    type="number"
                                    name="shipping_charges"
                                    value={orderInfo.shipping_charges}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border rounded-md"
                                />
                            </div>
                            {/* other charges */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Other Charges</label>
                                <input
                                    type="number"
                                    name="other_charges"
                                    value={orderInfo.other_charges}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border rounded-md"
                                />
                            </div>
                            {/* Order Comments */}
                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Order Comments</label>
                                <textarea
                                    name="order_comments"
                                    value={orderInfo.order_comments}
                                    onChange={handleInputChange}
                                    rows={3}
                                    className="w-full px-4 py-2 border rounded-md"
                                ></textarea>
                            </div>


                            {/* Order details */}
                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Order Details</label>
                                <textarea
                                    name="order_details"
                                    value={orderInfo.order_details}
                                    onChange={handleInputChange}
                                    rows={5}
                                    className="w-full px-4 py-2 border rounded-md"
                                ></textarea>
                            </div>

                        </div>

                        <div className="flex justify-end gap-4 mt-6">
                            <button
                                onClick={() => navigate("/all-order")}
                                type="button" className="px-6 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-900">
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="px-6 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 disabled:opacity-50"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Updating..." : "Update Order"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default EditOrder
